import { useMediaQuery } from 'react-responsive';
import type { SelectOption } from './MobileSelect';
import MobileSelect from './MobileSelect';
import DesktopSelect from './DesktopSelect';

interface SelectProps {
  options: SelectOption[];
  value: string;
  onChange: (value: string) => void;
  title?: string;
  width?: string | number;
}

export const Select = (props: SelectProps) => {
  const isMobile = useMediaQuery({ maxWidth: 768 });

  return isMobile ? <MobileSelect {...props} /> : <DesktopSelect {...props} />;
};

export default Select;
export type { SelectOption };
